(function () {
  // ── Hero image experiment ──────────────────────────────────────────────────

  function isV1(value) {
    var normalized = String(value || '').toLowerCase();
    return normalized === 'v1' || normalized === 'variant-1' || normalized === 'variation-1';
  }

  function normalizeVariant(value) {
    var normalized = String(value || '').toLowerCase().replace(/[\s_]/g, '-');
    if (normalized === 'control' || normalized === 'a' || normalized === '0') return 'control';
    if (isV1(normalized)) return 'v1';
    return null;
  }

  function getQueryVariant() {
    if (!window.location || !window.location.search) return null;

    var query = new URLSearchParams(window.location.search);
    return normalizeVariant(
      query.get('collection-exp') ||
      query.get('collectionExp') ||
      query.get('collection-cro-exp') ||
      query.get('collectionCroExp')
    );
  }

  function getExperimentVariant(root) {
    var queryVariant = getQueryVariant();
    if (queryVariant) return queryVariant;

    var candidates = [root, document.body, document.documentElement];

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;

      var value = node.getAttribute('data-collection-exp') || node.getAttribute('data-collection-cro-exp');
      if (value) return value;
    }

    return 'control';
  }

  function applyCollectionVariant(root) {
    root.classList.toggle('collection-cro--v1', isV1(getExperimentVariant(root)));
  }

  function syncAll() {
    document.querySelectorAll('[data-collection-cro-root]').forEach(applyCollectionVariant);
  }

  // ── Expert advice experiment ───────────────────────────────────────────────

  function getAdviceVariant() {
    var candidates = [document.body, document.documentElement];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;
      var value = node.getAttribute('data-collection-advice-exp');
      if (value) return value;
    }
    return 'control';
  }

  function resetAdviceTab() {
    var variant = getAdviceVariant();
    if (variant === 'control') return;

    var isMobile = window.innerWidth <= 749;
    var shouldReset =
      (variant === 'hide-mobile' && isMobile) ||
      (variant === 'hide-desktop' && !isMobile);

    if (!shouldReset) return;

    document.querySelectorAll('.expert-advice-tab[data-collection-tab="expert-advice"].collection-tab-active').forEach(function (tab) {
      var sectionId = tab.dataset.sectionId;
      var productsTab = document.querySelector(
        '[data-collection-tab="products"][data-section-id="' + sectionId + '"]'
      );
      if (productsTab) productsTab.click();
    });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────

  function start() {
    var observer = new MutationObserver(function () {
      syncAll();
      resetAdviceTab();
    });

    syncAll();
    resetAdviceTab();

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-collection-exp', 'data-collection-cro-exp', 'data-collection-advice-exp']
      });
    }

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-collection-exp', 'data-collection-cro-exp', 'data-collection-advice-exp']
    });

    window.addEventListener('resize', resetAdviceTab, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
